import { z } from 'zod'

import { StringDtoSchema } from '@hcr/api/shared'

export const LinkDtoBaseSchema = z.strictObject({
  label: StringDtoSchema,
})
